import { FC } from 'react';
import { IconsProps } from './Icons.type';

export const SunBlueIcon: FC<IconsProps> = () => (
    <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g opacity="0.1">
            <path
                d="M71.875 50C71.875 62.0812 62.0812 71.875 50 71.875C37.9188 71.875 28.125 62.0812 28.125 50C28.125 37.9188 37.9188 28.125 50 28.125C62.0812 28.125 71.875 37.9188 71.875 50Z"
                stroke="url(#paint0_linear_4592_7621)"
                strokeWidth="6.25"
            />
            <path
                d="M74.0891 21.4917C72.8687 22.7121 72.8687 24.6907 74.0891 25.9111C75.3095 27.1315 77.2881 27.1315 78.5085 25.9111L74.0891 21.4917ZM78.9956 25.424C80.216 24.2036 80.216 22.225 78.9956 21.0046C77.7752 19.7842 75.7966 19.7842 74.5762 21.0046L78.9956 25.424ZM21.0044 74.5765C19.7841 75.7971 19.7843 77.7757 21.0049 78.996C22.2254 80.2162 24.204 80.216 25.4243 78.9954L21.0044 74.5765ZM25.9113 78.5083C27.1315 77.2878 27.1313 75.3092 25.9108 74.0889C24.6903 72.8687 22.7116 72.8689 21.4914 74.0894L25.9113 78.5083ZM46.875 12.8081C46.875 14.534 48.2741 15.9331 50 15.9331C51.7259 15.9331 53.125 14.534 53.125 12.8081H46.875ZM53.125 12.5C53.125 10.7741 51.7259 9.375 50 9.375C48.2741 9.375 46.875 10.7741 46.875 12.5H53.125ZM46.875 87.5C46.875 89.2259 48.2741 90.625 50 90.625C51.7259 90.625 53.125 89.2259 53.125 87.5H46.875ZM53.125 87.1921C53.125 85.4662 51.7259 84.0671 50 84.0671C48.2741 84.0671 46.875 85.4662 46.875 87.1921H53.125ZM12.8081 53.125C14.534 53.125 15.9331 51.7259 15.9331 50C15.9331 48.2741 14.534 46.875 12.8081 46.875V53.125ZM12.5 46.875C10.7741 46.875 9.375 48.2741 9.375 50C9.375 51.7259 10.7741 53.125 12.5 53.125V46.875ZM87.5 53.125C89.2259 53.125 90.625 51.7259 90.625 50C90.625 48.2741 89.2259 46.875 87.5 46.875V53.125ZM87.1921 46.875C85.4662 46.875 84.0671 48.2741 84.0671 50C84.0671 51.7259 85.4662 53.125 87.1921 53.125V46.875ZM21.4916 25.9111C22.712 27.1315 24.6906 27.1315 25.911 25.9111C27.1314 24.6907 27.1314 22.7121 25.911 21.4917L21.4916 25.9111ZM25.4239 21.0046C24.2035 19.7842 22.2249 19.7842 21.0045 21.0046C19.7841 22.225 19.7841 24.2036 21.0045 25.424L25.4239 21.0046ZM74.5762 78.9956C75.7967 80.2159 77.7754 80.2157 78.9956 78.9952C80.2159 77.7747 80.2157 75.7961 78.9952 74.5758L74.5762 78.9956ZM78.5082 74.0889C77.2877 72.8687 75.3091 72.8689 74.0888 74.0894C72.8686 75.3099 72.8688 77.2885 74.0893 78.5088L78.5082 74.0889ZM78.5085 25.9111L78.9956 25.424L74.5762 21.0046L74.0891 21.4917L78.5085 25.9111ZM25.4243 78.9954L25.9113 78.5083L21.4914 74.0894L21.0044 74.5765L25.4243 78.9954ZM53.125 12.8081V12.5H46.875V12.8081H53.125ZM53.125 87.5V87.1921H46.875V87.5H53.125ZM12.8081 46.875H12.5V53.125H12.8081V46.875ZM87.5 46.875H87.1921V53.125H87.5V46.875ZM25.911 21.4917L25.4239 21.0046L21.0045 25.424L21.4916 25.9111L25.911 21.4917ZM78.9952 74.5758L78.5082 74.0889L74.0893 78.5088L74.5762 78.9956L78.9952 74.5758Z"
                fill="url(#paint1_linear_4592_7621)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_4592_7621"
                x1="50"
                y1="28.125"
                x2="50"
                y2="71.875"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#2193B0" />
                <stop offset="0.02" stopColor="#2193B0" />
                <stop offset="1" stopColor="#6DD5ED" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_4592_7621"
                x1="50"
                y1="12.5"
                x2="50"
                y2="87.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#2193B0" />
                <stop offset="0.02" stopColor="#2193B0" />
                <stop offset="1" stopColor="#6DD5ED" />
            </linearGradient>
        </defs>
    </svg>
);
